module.exports = __webpack_public_path__ + "static/media/img_13.2cd81b09.png";